module.exports = __webpack_public_path__ + "static/media/11.92024702.jpeg";